export class ConfigData {
  constructor(
    public key: string,
    public value: string
  ){}

  public asBoolean(): boolean | undefined {
    if(this.value === 'true' || this.value === '1'){
      return true
    }
    if(this.value === 'false' || this.value === '0'){
      return false
    }
    console.warn(`invalid boolean value '${this.value}' for config key '${this.key}'`)
    return undefined
  }

  public static clone(cd: ConfigData): ConfigData{
    return new ConfigData(cd.key, cd.value)
  }
}
